const MIME_EXTENSIONS: Record<string, string> = {
  'audio/wav': 'wav',
  'audio/x-wav': 'wav',
  'audio/wave': 'wav',
  'audio/mpeg': 'mp3',
  'audio/mp3': 'mp3',
  'audio/ogg': 'ogg',
}

// A real extension is short and alphanumeric. Reject anything else (e.g. a
// `song.<500 chars>` tail) so the parsed extension can't defeat the
// fixed-length goal or leak odd characters into the S3 key.
const EXTENSION_RE = /^[a-z0-9]{1,8}$/

function resolveExtension(file: File): string {
  const dot = file.name.lastIndexOf('.')
  if (dot > 0 && dot < file.name.length - 1) {
    const ext = file.name.slice(dot + 1).toLowerCase()
    if (EXTENSION_RE.test(ext)) {
      return ext
    }
  }
  return MIME_EXTENSIONS[file.type.toLowerCase()] ?? ''
}

// The backend derives the S3 key from the uploaded file's name, and long
// original names overflow the stored location. Send a UUID name instead so the
// key is fixed-length; the human-readable name travels in the separate `name`
// field.
export function uuidFilename(file: File): File {
  const ext = resolveExtension(file)
  const name = ext ? `${crypto.randomUUID()}.${ext}` : crypto.randomUUID()
  return new File([file], name, {
    type: file.type,
    lastModified: file.lastModified,
  })
}
